import { render } from "./ModalErroInfo.vue?vue&type=template&id=421d7d90&scoped=true&ts=true"
import script from "./ModalErroInfo.vue?vue&type=script&lang=ts"
export * from "./ModalErroInfo.vue?vue&type=script&lang=ts"

import "./ModalErroInfo.vue?vue&type=style&index=0&id=421d7d90&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421d7d90"]])

export default __exports__